export * from './dlg-tips.component';
